import { api } from './api';

// Admin "Online-Benutzer"-Panel — pollt im Hintergrund, deshalb separat
// vom regulären User-Service damit die Standard-Listen-Caches nicht
// versehentlich mit invalidiert werden.
export const onlineUsersApi = api.injectEndpoints({
  endpoints: (build) => ({
    getOnlineUsers: build.query({
      query: (minutes = 10) => ({
        url: `admin/users/online?minutes=${minutes}`,
      }),
    }),
  }),
});

export const { useGetOnlineUsersQuery } = onlineUsersApi;
